import { GatsbyImage } from "gatsby-plugin-image"
import { getGatsbyImageData } from "gatsby-source-sanity"
import { classNames } from "../../utils/helpers"

// ** Custom Components
import Box from "../Box"

const Figure = ({ value }: any) => {
  const isHero = value.tags?.map((tag: string) => tag === "hero-image")[0]
  const isLogo = value.tags?.map((tag: string) => tag === "logo")[0]
  const isFullWidth = value.tags?.includes("full-width")
  const isMedia = value._type === "media"

  const gatsbyImageData: any = getGatsbyImageData(
    isHero || isMedia ? value?.image_desktop?.asset : value?.asset,
    { ...value?.asset },
    {
      // @ts-ignore
      projectId: process.env.SANITY_PROJECT_ID,
      // @ts-ignore
      dataset: process.env.SANITY_DATASET,
    }
  )

  return (
    <>
      {!isHero && isMedia && !isLogo ? (
        <div className="w-full">
          <GatsbyImage
            className={classNames(
              isFullWidth || isMedia ? "w-full h-auto" : "w-64"
            )}
            image={gatsbyImageData}
            alt={value?.alt || ""}
            objectFit="contain"
          />
        </div>
      ) : !isHero && isMedia && isLogo ? (
        <Box className="w-[187px] mx-auto lg:mx-0 h-auto mt-4 lg:mt-8">
          <GatsbyImage
            image={gatsbyImageData}
            alt={value?.alt || ""}
            objectFit="contain"
          />
        </Box>
      ) : (
        <figure className="my-8">
          <GatsbyImage
            image={gatsbyImageData}
            alt={(isHero ? value?.alt : value?.asset?.filename) || "figure"}
          />
        </figure>
      )}
    </>
  )
}

export default Figure
